import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CoreModule } from '../core';
import { TransactionRoutingModule } from './misc-routing.module';
import { BranchAddComponent } from './branch.add.component';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { BranchesComponent } from './branches.component';

@NgModule({
  imports: [CommonModule, BrowserModule, FormsModule, ReactiveFormsModule, NgSelectModule,
    CoreModule, TransactionRoutingModule, HttpModule],
  declarations: [BranchAddComponent, BranchesComponent],
  providers: []
})
export class MiscModule { }
